// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type GiftingProposal_GiftingScenarioFragment = { __typename?: 'GiftingProposalScenario', id: string, order: number, isDefault: boolean, isBaseline: boolean, displayName: string, projections: { __typename?: 'GiftingProposalProjections', inEstateValueAfterTax: CurrencyUSD, inEstateValueBeforeTax: CurrencyUSD, outOfEstateCharitableValue: CurrencyUSD, outOfEstateFamilyValue: CurrencyUSD, outOfEstateTotalValue: CurrencyUSD, taxableGift: CurrencyUSD, totalValue: CurrencyUSD }, scenarioCashFlows?: Array<{ __typename?: 'GiftingProposalCashFlow', id: string, order: number, displayName: string, amount: CurrencyUSD, annuallyRecurring?: boolean | null, startYear: number, endYear?: number | null, cashFlowType: Types.GiftingProposalCashFlowCashFlowType, portfolio?: { __typename?: 'GiftingProposalPortfolio', id: string, displayName: string } | null }> | null, scenarioGifts?: Array<{ __typename?: 'GiftingProposalGift', id: string, displayName: string, order: number, amount: CurrencyUSD, annuallyRecurring?: boolean | null, discount?: boolean | null, discountPercentage?: Percent | null, startYear: number, endYear?: number | null, growthPercentage?: Percent | null, isTaxable: boolean, nonTaxableGiftType?: Types.GiftingProposalGiftNonTaxableGiftType | null, senders?: Array<{ __typename?: 'GiftingProposalGiftSender', id: string, grantor: { __typename?: 'ClientProfile', id: string, displayName: string } }> | null }> | null };

export type GiftProposalFragment = { __typename?: 'GiftingProposal', id: string, lengthOfAnalysis: number, preTaxReturnPercentageHigh?: Percent | null, preTaxReturnPercentageLow?: Percent | null, preTaxReturnPercentageMedium?: Percent | null, status: Types.GiftingProposalStatus, showAfterEstateTax?: boolean | null, selectedYearOfAnalysis?: number | null, selectedPreTaxReturnCategory?: Types.GiftingProposalSelectedPreTaxReturnCategory | null, taxDragPercentageHigh?: Percent | null, taxDragPercentageLow?: Percent | null, taxDragPercentageMedium?: Percent | null, inEstatePortfolioValue: CurrencyUSD, exemptionGrowthRate?: Percent | null, outOfEstatePortfolios?: Array<{ __typename?: 'GiftingProposalPortfolio', id: string, portfolioType: Types.GiftingProposalPortfolioPortfolioType, order: number, startingAssetValue: CurrencyUSD, displayName: string }> | null, giftingScenarios?: Array<(
    { __typename?: 'GiftingProposalScenario' }
    & GiftingProposal_GiftingScenarioFragment
  )> | null, baseCashFlows?: Array<{ __typename?: 'GiftingProposalCashFlow', id: string, order: number, displayName: string, startYear: number, growthPercentage?: Percent | null, endYear?: number | null, cashFlowType: Types.GiftingProposalCashFlowCashFlowType, annuallyRecurring?: boolean | null, amount: CurrencyUSD }> | null };

export const Operations = {
  Fragment: {
    GiftingProposal_GiftingScenario: 'GiftingProposal_GiftingScenario' as const,
    GiftProposal: 'GiftProposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GiftingProposal_GiftingScenarioFragmentDoc = gql`
    fragment GiftingProposal_GiftingScenario on GiftingProposalScenario {
  id
  order
  isDefault
  isBaseline @client
  projections {
    inEstateValueAfterTax
    inEstateValueBeforeTax
    outOfEstateCharitableValue
    outOfEstateFamilyValue
    outOfEstateTotalValue
    taxableGift
    totalValue
  }
  scenarioCashFlows {
    id
    order
    displayName
    amount
    annuallyRecurring
    startYear
    endYear
    cashFlowType
    portfolio {
      id
      displayName
    }
  }
  scenarioGifts {
    id
    displayName
    order
    amount
    annuallyRecurring
    discount
    discountPercentage
    startYear
    endYear
    growthPercentage
    isTaxable
    nonTaxableGiftType
    senders {
      id
      grantor {
        id
        displayName
      }
    }
  }
  displayName
}
    `;
export const GiftProposalFragmentDoc = gql`
    fragment GiftProposal on GiftingProposal {
  id
  lengthOfAnalysis
  preTaxReturnPercentageHigh
  preTaxReturnPercentageLow
  preTaxReturnPercentageMedium
  status
  showAfterEstateTax
  selectedYearOfAnalysis
  selectedPreTaxReturnCategory
  taxDragPercentageHigh
  taxDragPercentageLow
  taxDragPercentageMedium
  inEstatePortfolioValue
  exemptionGrowthRate
  outOfEstatePortfolios {
    id
    portfolioType
    order
    startingAssetValue
    displayName
  }
  giftingScenarios {
    ...GiftingProposal_GiftingScenario
  }
  baseCashFlows {
    id
    order
    displayName
    startYear
    growthPercentage
    endYear
    cashFlowType
    annuallyRecurring
    amount
  }
}
    ${GiftingProposal_GiftingScenarioFragmentDoc}`;